import type { UseFormReturn } from 'react-hook-form';
import { useFormState } from 'react-hook-form';
import { FieldGroup, Input, TextField } from '@launchpad-ui/components';

import { RequiredLabel } from '../components/RequiredLabel';
import type { MetricForm } from '../formUtils';

import styles from './UnitFormField.module.css';

interface UnitFormFieldProps {
  context: UseFormReturn<MetricForm>;
}

const FIELD_NAME = 'unit';

export const UnitFormField: React.FC<UnitFormFieldProps> = ({ context }) => {
  const { register } = context;
  const { errors } = useFormState({ control: context.control, name: FIELD_NAME });
  const value = context.watch('unit');

  return (
    <FieldGroup errorMessage={errors.unit?.message}>
      <TextField>
        <RequiredLabel label="Unit of measure" htmlFor={FIELD_NAME} />
        <Input
          {...register(FIELD_NAME, { required: 'Unit of measure is required', shouldUnregister: true })}
          value={value}
          placeholder="ex: bytes, ms"
          id={FIELD_NAME}
          className={styles.unitFormFieldInput}
        />
      </TextField>
    </FieldGroup>
  );
};
